import {
    ADD_EXPENSE_REQUEST,
    GET_EXPENSES_REQUEST,
    GET_EXPENSES_RESPONSE,
    EDIT_EXPENSE_REQUEST,
    GET_EXPENSE_DETAILS_REQUEST,
    GET_EXPENSE_DETAILS_RESPONSE,
    DELETE_EXPENSE_REQUEST,
    GET_MIMAR_PROFIT_REQUEST,
    GET_MIMAR_PROFIT_RESPONSE,
  } from "./types";
  
  // list
  export const getExpensesRequest = (payload) => ({
    type: GET_EXPENSES_REQUEST,
    payload,
  });
  
  export const getExpensesResponse = (payload) => ({
    type: GET_EXPENSES_RESPONSE,
    payload,
  });
  
  // add
  export const addExpenseRequest = (payload) => ({
    type: ADD_EXPENSE_REQUEST,
    payload,
  });
  
  // edit
  export const editExpenseRequest = (payload) => ({
    type: EDIT_EXPENSE_REQUEST,
    payload,
  });
  
  // get by id (view)
  export const getExpenseDetailsRequest = (payload) => ({
    type: GET_EXPENSE_DETAILS_REQUEST,
    payload,
  });
  
  export const getExpenseResponse = (payload) => ({
    type: GET_EXPENSE_DETAILS_RESPONSE,
    payload,
  });
  
  export const deleteExpenseRequest = (payload) => ({
    type: DELETE_EXPENSE_REQUEST,
    payload,
  });
  export const getMimarProfitRequest = (payload) => ({
    type: GET_MIMAR_PROFIT_REQUEST,
    payload,
  });
  export const getMimarProfitResponse = (payload) => ({
    type: GET_MIMAR_PROFIT_RESPONSE,
    payload,
  });